export default "__VITE_ASSET__CfSDElVr__"